import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ButtonWithIcon from './ButtonWithIcon'
import styles from './ToggleButtonWithIcon.icss'

class ToggleButtonWithIcon extends React.Component {
	constructor(props) {
		super(props)
		this.state = { value: this.props.value || false }
	}

	render() {
		const {	iconNameOn, iconNameOff, classNameOn, classNameOff, onChange, ignoreClick, title } = this.props
		const onClick = () => {
			if (!ignoreClick) {
				this.setState({ value: !this.state.value }, () => onChange(this.state.value)) // eslint-disable-line react/no-access-state-in-setstate
			}
		}
		const on = this.state.value
		return (
			<ButtonWithIcon
				title={title}
				iconName={this.state.value ? iconNameOn : iconNameOff}
				onClick={onClick}
				fullWidth={false}
				classes={{
					root: styles.buttonRoot
				}}
				className={classNames(styles.button, on ? classNameOn : classNameOff)}
			/>
		)
	}
}

ToggleButtonWithIcon.propTypes = {
	title: PropTypes.string,
	iconNameOn: PropTypes.string,
	iconNameOff: PropTypes.string,
	classNameOn: PropTypes.string,
	classNameOff: PropTypes.string,
	value: PropTypes.bool,
	ignoreClick: PropTypes.bool,
	onChange: PropTypes.func
}

ToggleButtonWithIcon.defaultProps = {
	title: undefined,
	iconNameOn: undefined,
	iconNameOff: undefined,
	classNameOn: undefined,
	classNameOff: undefined,
	value: false,
	ignoreClick: false,
	onChange: () => {}
}

ToggleButtonWithIcon.contextTypes = {
	translate: PropTypes.func
}

export default ToggleButtonWithIcon



// WEBPACK FOOTER //
// ./src/components/ToggleButtonWithIcon.jsx